"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Cell = void 0;
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var utils_1 = require("../../utils");
var paper_1 = __importDefault(require("../paper"));
var useStyles = utils_1.makeStyles(function (theme) { return ({
    root: {
        flexGrow: 1
    },
    paper: {
        color: theme.palette.text.secondary
    },
    titleContainer: {
        marginBottom: theme.spacing(2)
    }
}); });
var CellTitle = function (props) {
    var title = props.title;
    if (!title) {
        return null;
    }
    return react_1["default"].createElement(Typography_1["default"], { variant: "h5" }, title);
};
exports.Cell = function (props) {
    var classes = useStyles();
    var _a = props.xs, xs = _a === void 0 ? 12 : _a, xl = props.xl, _b = props.sm, sm = _b === void 0 ? 6 : _b, _c = props.md, md = _c === void 0 ? 6 : _c, lg = props.lg, children = props.children, title = props.title, description = props.description, classNames = props.classNames, PaperComponent = props.PaperComponent, _d = props.withPaper, withPaper = _d === void 0 ? true : _d;
    var content = (react_1["default"].createElement(react_1["default"].Fragment, null,
        (title || description) && (react_1["default"].createElement("div", { className: classes.titleContainer },
            react_1["default"].createElement(CellTitle, { title: title }),
            description ? react_1["default"].createElement(Typography_1["default"], null, description) : null)),
        children));
    return (react_1["default"].createElement(Grid_1["default"], { item: true, xs: xs, xl: xl, sm: sm, md: md, lg: lg, className: classNames === null || classNames === void 0 ? void 0 : classNames.cell }, withPaper === false ? (content) : PaperComponent ? (react_1["default"].createElement(PaperComponent, null, content)) : (react_1["default"].createElement(paper_1["default"], { className: classes.paper + " " + ((classNames === null || classNames === void 0 ? void 0 : classNames.paper) || '') }, content))));
};
exports["default"] = exports.Cell;
